import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import {List} from 'immutable'
import { connect } from 'react-redux'
import {createStructuredSelector} from 'reselect'
import styled from 'styled-components'
import {MESSAGES_TYPES} from 'widget/constants'
import TypingPlaceholder from './TypingPlaceholder'
import selectors from '../../store/selectors'
import Scroll from '../../components/Scroll'
import QuickButtons from '../QuickButtons'
import { FULLSCEEN_WIDTH_BREAKPOINT } from 'src/constants'


export class Messages extends Component {

  refMessages = null;

  componentDidMount() {
    this.scrollToBottom()
  }

  componentDidUpdate() {
    this.scrollToBottom()
  }

  scrollToBottom = () => {
    if (this.refMessages) this.refMessages.scrollToBottom()
  };

  getAvatar = isLiveAgent => {
    const { avatarBot, config: { liveAgentAvatar } } = this.props
    return isLiveAgent && liveAgentAvatar ? liveAgentAvatar : avatarBot
  }

  getComponentToRender = message => {
    const { avatarUser, config: { speechBubbles } } = this.props
    const ComponentToRender = message.get('component')

    if (message.get('type') === MESSAGES_TYPES.CUSTOM_COMPONENT) {
      return <ComponentToRender
        {...message.get('props')}
        onReady={this.scrollToBottom}
      />
    }

    return <ComponentToRender
      avatarBot={this.getAvatar(message.get('isLiveAgent'))}
      avatarUser={avatarUser}
      speechBubbles={speechBubbles}
      message={message}
      onReady={this.scrollToBottom}
    />
  };




  render() {
    const {messages, isFetching, isLive, config: { speechBubbles }} = this.props

    return (
      <MessagesContainer speechBubbles={speechBubbles}>
        <Scroll ref={ref => this.refMessages = ref} style={{ height: '100%' }} >
          <div style={{ paddingTop: '10px', overflow: 'hidden'}}>
            {
              messages.map((message, index) =>
                (
                  <MessageRow
                    key={`msg_${index}`}
                    isLast={!isFetching && (index + 1) === messages.size}
                  >
                    {this.getComponentToRender(message)}
                  </MessageRow>
                )
              )
            }
            <TypingPlaceholder
              active={isFetching}
              avatarBot={this.getAvatar(isLive)}
            />
          </div>
        </Scroll>
        <QuickButtons />
      </MessagesContainer>
    )
  }
}

Messages.propTypes = {
  messages: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  avatarBot: PropTypes.string,
  avatarUser: PropTypes.string,
  config: PropTypes.shape({
    speechBubbles: PropTypes.bool,
    liveAgentAvatar: PropTypes.string
  }),
  isFetching: PropTypes.bool,
  isLive: PropTypes.bool,
  onSlideButtonClick: PropTypes.func,
}
Messages.defaultProps = {
  messages: new List(),
}


const mapStateToProps = createStructuredSelector({
  isFetching: selectors.selectIsFetching,
  messages: selectors.selectMessages,
  isLive: selectors.selectIsLive
})

export default connect(mapStateToProps)(Messages)


const MessagesContainer = styled.div`
  position: relative;
  background-color: var(--clr-white-to-grey-4, #fff);
  flex: 2;
  overflow: auto;
  @media screen and (max-width: ${FULLSCEEN_WIDTH_BREAKPOINT}px) {
    flex: 1;
    overflow: auto;
    height: auto;
  }
`

const MessageRow = styled.div`
  margin-top: 5px;
  margin-right: 10px;
  margin-bottom: ${props => props.isLast ? 150 : 5}px;
  margin-left: 2px;
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Messages/index.js